module.exports = "/images/heart.png?0cd7635f3dcd44b2457af16ac44bfdef";